import { useEffect } from 'react';
import { getSupabase } from '../utils/supabaseClient';

const BACKEND = (process.env.REACT_APP_BACKEND || 'local').toLowerCase();
const TABLES = ['todos', 'todo_tags', 'habits', 'todo_tag_map', 'habit_tag_map', 'todo_stock_items'];

/** Realtime は変更シグナルだけを受け、実データは既存の差分同期で取得する。 */
export const useTodoRealtimeSync = (sync: () => Promise<void>) => {
  useEffect(() => {
    if (BACKEND !== 'supabase') return;
    let disposed = false;
    let timer: number | undefined;
    let syncing = false;
    let pending = false;

    const run = async () => {
      if (syncing) {
        pending = true;
        return;
      }
      syncing = true;
      try {
        await sync();
      } catch (error) {
        console.error('Failed to sync after Todo Realtime notification:', error);
      } finally {
        syncing = false;
        if (pending && !disposed) {
          pending = false;
          schedule();
        }
      }
    };

    const schedule = () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => { void run(); }, 500);
    };

    const channel = getSupabase().channel('todo-sync-trigger');
    TABLES.forEach(table => {
      channel.on('postgres_changes', { event: '*', schema: 'public', table }, schedule);
    });
    channel.subscribe();

    return () => {
      disposed = true;
      window.clearTimeout(timer);
      void getSupabase().removeChannel(channel);
    };
  }, [sync]);
};
